import React from 'react';
export const CFIconLogOut = {
    alias: 'log-out',
    defaultTitle: 'Log Out',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M8 5c0 .55-.45 1-1 1H6v12h1c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2c.55 0 1 .45 1 1Zm10.004 2.425 2.814 4A.998.998 0 0 1 20.8 12.6l-3 4a.998.998 0 0 1-1.4.2.999.999 0 0 1-.2-1.4L18 13h-8a1 1 0 1 1 0-2h8a.15.15 0 0 1 .047.009.2.2 0 0 0 .039.009l-1.718-2.443a1 1 0 1 1 1.636-1.15Z' }))),
};
